<template>
  <div id="notification-modal" class="notification-modal">
      <div class="title-row">
        <p class="title"><span class="title-container">{{container}}</span>  --  <span class="title-date">{{date}}</span></p>
      </div>
      <p class="text">
        <span class="user" v-bind:style="{color: color}">{{user}}</span>
        {{text}}
      </p>
      <div class="confirm-button-container">
        <button class="confirm-button" @click="closeModal()">ACEPTAR</button>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";

export default {
  name: "notificationModal",
  props: ["container", "text", "user", "date", "color"],
  data() {
    return { };
  },
  computed: {
    ...mapGetters("user", {
      authorized: "authorized",
    }),
  },
  mounted () {
    var thisGlobal = this
    setTimeout(function(){ 
       thisGlobal.showModal() 
    }, 300);
   
  },
  methods: {
    showModal: function(){
      var modal = document.getElementById("notification-modal");
      modal.classList.toggle("show");
    },
    closeModal: function() {
      var notification = {
          visible: false,
          container: '',
          text: '',
          user: '',
          date: '',
          color: '',
      }
      this.$store.dispatch('change_notification', notification)
    }
  },
};
</script>

<style lang= "scss" >
.notification-modal{
  z-index: 100;
  padding: 1em 2em;
  position: absolute;
  top: -500px;
  left: 0;
  width: 100vw;
  /* height: 150px; */

  background-color: white;
  /*border-radius: 10px;*/
  box-shadow: 0px 3px 10px rgba(0,0,0,0.3);

  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;

  opacity: 0;
}
.notification-modal.show{
  top: 0px;
  opacity: 1;
}
.confirm-button-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-button {
  background-color: $button-background;
  border: none;
  color: white;
  padding: 12px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin-top: 25px;
  border-radius: 25px;
  width: 45%;
  box-shadow: 0px 3px 6px rgba(0,0,0,0.3);
}
p{
  margin-bottom: 0;
}
p.text, span.user{
  font-size: 1rem;
}
.title-row{
  
  width: 100%;
}
.title{
  width: 100%;
  display: flex;
  flex-direction: row;
}
.title-container{
  font-weight: 600;
  font-size: 1rem;
}
.title-date-container{
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;
}
.title-date{
  color: #555555;
  font-size: 0.9rem;
}


</style>
